import { getDefaultItemPrice, getLowestItemPrice, getOrderItemByItemId } from '@vista/omnichannel-components-domain';
export const getPrice = (sellableItem, priceRestriction) => {
    const orderItem = getOrderItemByItemId(sellableItem.itemId, priceRestriction);
    if (orderItem)
        return orderItem.price;
    const itemPrice = priceRestriction
        ? getLowestItemPrice(sellableItem.prices)
        : getDefaultItemPrice(sellableItem.prices);
    return itemPrice.price;
};
